import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';
import {
  getUnderwriterRemittancesByOrderId,
  sendUnderwriterRemittancesByEscrowFileIdAsync,
} from '../../../API/order/escrow/EscrowAPI';

export const { slice: getRemittanceSlice, asyncAction: getRemittanceAction } = createKeyedDataAsyncSlice(
  'getRemittanceSlice',
  getUnderwriterRemittancesByOrderId,
  (orderId) => orderId
);

export const { slice: sendRemittanceSlice, asyncAction: sendRemittanceAction } = createKeyedDataAsyncSlice(
  'sendRemittanceSlice',
  sendUnderwriterRemittancesByEscrowFileIdAsync,
  (sendRequest) => sendRequest.escrowFileId
);
